export default __webpack_public_path__ + "assets/health-insurance-component.edbbae96.svg";